import { ForeignKey, UserAccountLike, UserAccount, Base } from "../../../core/db/models/index";
import FortumDatabase from "../index";
import { WithAllType, arrayOrCollection } from "../../../core/db/index";
import { Location } from "./index";


export interface CustomerLike extends Base
{
    id: number;
    location_id: number;
    user_account_id: number;
    number: string;
    nfc_token: string;
    first_name: string;
    last_name: string;
    details: string;
    import_id: Date;
    access_token: string;

    location?: Location;
    user_account?: UserAccountLike;
}

export class Customer
{
    public static withAll(db: FortumDatabase, targetCustomers: WithAllType<CustomerLike>): PromiseLike<CustomerLike[]>
    {
        let customers: CustomerLike[];
        return arrayOrCollection(targetCustomers).then((resolvedCustomers) =>
        {
            customers = resolvedCustomers;

            return Promise.all([
                db.Location.where('id').anyOf(customers.map(o => o.location_id)).toArray(),
                db.UserAccount.where('id').anyOf(customers.map(o => o.user_account_id).filter(o => o != null)).toArray(),
            ]);
        }).then((results) =>
        {
            let locations: Location[] = results[0];
            let userAccounts: UserAccountLike[] = results[1];
            for (let customer of customers)
            {
                customer.location = locations.find(o => o.id == customer.location_id);
                customer.user_account = userAccounts.find(o => o.id == customer.user_account_id);
            }

            return UserAccount.withAll(db, userAccounts);

        }).then(() =>
        {
            return customers;
        });
    }
}